import { Component, ElementRef, HostListener, Injectable, OnDestroy, OnInit, ViewChild, Inject } from '@angular/core';

import { Keepalive } from '@ng-idle/keepalive';
import { EventTargetInterruptSource, Idle } from '@ng-idle/core';

import { AuthService } from './common/service/authentication';
import { CookieWarningComponent, HeaderComponent, NavBarComponent } from './common/';
import { SessionTimeoutComponent } from './common/component/session-timeout/session-timeout.component';

import { NotificationService, CommonService, GrowlService } from './common/service';
import { catchError, tap } from 'rxjs/operators';
import { NgIf, NgClass } from '@angular/common';
import { RouterOutlet, Router, Route } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { ToastModule } from 'primeng/toast';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [NgIf, RouterOutlet, NavBarComponent, HeaderComponent, SessionTimeoutComponent, ToastModule, NgClass],
  providers: [CookieWarningComponent, NavBarComponent, HeaderComponent, Idle, SessionTimeoutComponent,
    GrowlService]
})
export class AppComponent implements OnInit, OnDestroy {
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler() {
    this.authService.logout();
  }
  @ViewChild(SessionTimeoutComponent) sessionTimeoutRef: SessionTimeoutComponent;
  idleState = 'NOT_STARTED';
  timedOut = false;
  lastPing?: Date = null;
  showMaintMessage = false;
  inMaint = false;
  idleDuration = 900;
  timeoutDuration = 300;
  msgs = [];
  message: any;
  site_StrapLine_Number: number;
  showActionMessage = false;

  constructor(
    private cookieWarning: CookieWarningComponent,
    private element: ElementRef,
    private navBar: NavBarComponent,
    private primeng: PrimeNG,
    @Inject(Idle) private idle: Idle,
    @Inject(Keepalive) private keepalive: Keepalive,
    @Inject(NotificationService) public notificationService: NotificationService,
    @Inject(CommonService) public commonService: CommonService,
    @Inject(GrowlService) public growlService: GrowlService,
    @Inject(AuthService) public authService: AuthService,
    private route: Router
  ) {
  }

  ngOnInit() {
    this.primeng.ripple.set(true);
    Notification.requestPermission();
    this.idle.setIdle(this.idleDuration);
    this.idle.setTimeout(this.timeoutDuration);
    this.idle.setInterrupts([new EventTargetInterruptSource(this.element.nativeElement, 'keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')]);

    this.idle.onIdleEnd.pipe(tap(() => {
      this.idleState = 'NO_LONGER_IDLE';
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();

    this.idle.onTimeout.pipe(tap(() => {
      this.idleState = 'TIMED_OUT';
      this.timedOut = true;
      this.sessionTimeoutRef.logout();
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();

    this.idle.onIdleStart.pipe(tap(() => {
      this.idleState = 'IDLE_START';
      this.sessionTimeoutRef.showTimeoutWarning = true;
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();

    this.idle.onTimeoutWarning.subscribe((countdown: any) => {
      this.idleState = 'IDLE_TIME_IN_PROGRESS';
      this.sessionTimeoutRef.progressCount = (Math.floor(((this.reverseNumber(countdown) / this.timeoutDuration) * 100)));
      this.sessionTimeoutRef.countMinutes = (Math.floor(countdown / 60));
      this.sessionTimeoutRef.countSeconds = countdown % 60;
      if (this.sessionTimeoutRef.countSeconds === 100 && this.authService.isAuthenticated() === false) {
        this.authService.logout();
      }
    });

    this.keepAliveCheck();

    // if(this.authService.getUser().action_required){
    //   this.showActionMessage = true;
    // }
  }

  keepAliveCheck() {
    this.keepalive.interval(60);
    this.keepalive.onPing.pipe(tap(async () => {
      await this.authService.checkAuthenticationStatus();
      this.inMaint = this.authService.inMaint();
      this.isMaint();
      this.navBar.visible();
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();

    this.notificationService.showNotifications();
  }

  closeMaintMessage() {
    this.authService.closeMaintStatus(this.site_StrapLine_Number).pipe(tap(() => {
      this.showMaintMessage = false;
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();
  }

  isMaint() {
    this.authService.getMaintStatus().pipe(tap((x) => {
      if (this.commonService.isNullOrUndefined(x) || x.length === 0) {
        this.showMaintMessage = false;
        return;
      }
      this.showMaintMessage = true;
      this.site_StrapLine_Number = x[0].site_strapline_number;
      this.message = x[0].system_information;
    }), catchError((error) => {
      //this.growlService.error(error);
      return error;
    })).subscribe();
  }

  ngOnDestroy() {
    this.sessionEnd();
    this.idle.onIdleStart.unsubscribe();
    this.idle.onTimeoutWarning.unsubscribe();
    this.idle.onIdleEnd.unsubscribe();
  }

  reverseNumber(countdown: number) {
    return (this.timeoutDuration - (countdown - 1));
  }

  sessionStart() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
    this.cookieWarning.accept();
  }

  sessionEnd() {
    this.idle.stop();
  }

  forceRefresh() {
    window.location.reload();
  }

  goToActions() {
    this.route.navigate(['/pod/maintenance/renewal']);
    this.showActionMessage = false;
    // this.saveActionMessage();
  }

  closeActionMessage() {
    this.showActionMessage = false;
    // this.saveActionMessage();
  }

  saveActionMessage() {
    // let user = this.authService.getUser();
    // user.action_required = false;

    // this.authService.updateAction(user)
    //   .pipe(tap(() => {
    //   })).subscribe();
  }

}
